var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckboxFalse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_4_5",
    "data-name": "Symbol 4 \\u2013 5",
    transform: "translate(-916 -1706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_96",
    className: "cls-1",
    "data-name": "Rectangle 96",
    transform: "translate(916 1706)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    className: "cls-2",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    x: 0.5,
    y: 0.5,
    className: "cls-3",
    rx: 3.5
  })))));
}
export default __webpack_public_path__ + "static/media/ic_checkbox_false.027511bd.svg";
export { SvgIcCheckboxFalse as ReactComponent };